import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import { BaseErrorResponse } from 'models/_base';
import {
  CustomTemplateCreatePayload,
  CustomTemplateWithLocales,
} from 'models/automation/CustomTemplates';
import API from 'services/API';

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<unknown, BaseErrorResponse, CustomTemplateCreatePayload>,
  'mutationFn' | 'mutationKey'
>;

const createCustomTemplate = (payload: CustomTemplateCreatePayload) => {
  return API.post<CustomTemplateWithLocales, BaseErrorResponse>(
    '/api/internal/automation/custom-templates',
    payload,
  );
};

const useCreateCustomTemplateMutation = ({
  ...options
}: ReactQueryMutationOptions = {}) => {
  return useAppMutation({
    mutationFn: createCustomTemplate,
    ...options,
  });
};

export default useCreateCustomTemplateMutation;
